import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { PostConsentimientoNuevo } from '../../../actions';
import SweetAlert from 'sweetalert2';

const ConsentimientoUsuarioNuevo = () => {
  const dispatch = useDispatch()
  const token = localStorage.getItem('token')
  const [ input, setInput ] = useState({
    nombreApellido: '',
    dni: '',
    domicilio: ''
  })


  const handleChange = (e) => {
    setInput({
        ...input,
        [e.target.name]: e.target.value
    })
  }

  const handleSubmit= (e) =>{
    e.preventDefault();
    dispatch(PostConsentimientoNuevo(input,token))
    
    // Muestra la alerta con SweetAlert
    SweetAlert.fire({
      title: '¡Éxito!',
      text: 'Se cargó correctamente',
      icon: 'success',
      confirmButtonText: 'Aceptar',
    });

    setTimeout(()=>{
      window.location.replace('/formularios');
    }, 1000)
  }


  return (
    <form className='flex flex-col items-center justify-center gap-5 rounded-xl bg-white p-12 shadow-xl'>
        <div className='flex flex-col gap-2'>
          <span>Nombre y apellido:</span>
          <input type="text" name='nombreApellido' className='border rounded-xl p-2 w-72 shadow' placeholder='Nombre y apellido del paciente' onChange={handleChange}/>
        </div>
        <div className='flex flex-col gap-2'>
          <span>DNI del paciente:</span>
          <input type="text" name='dni' className='border rounded-xl p-2 w-72 shadow' placeholder='DNI' onChange={handleChange}/>
        </div>
        <div className='flex flex-col gap-2'>
          <span>Domicilio Del Cultivo:</span>
          <input type="text" name='domicilio' className='border rounded-xl p-2 w-72 shadow' placeholder='Domicilio real' onChange={handleChange}/>
        </div>
        
        <p className='font-bold text-background_home'>SE UTILIZARÁ LA FIRMA DEL DDJJ</p>
        <button onClick={handleSubmit} className='bg-background_home p-2 rounded text-white font-bold'>Enviar</button>
    </form>
  )
}

export default ConsentimientoUsuarioNuevo